export type IdeaIssueStrategy = 'putSpread' | 'callSpread' | 'ironCondor';

export const ISSUE_REASONS = [
  'stale_quote',
  'wide_spread',
  'wrong_credit',
  'strikes_wrong',
  'other',
] as const;
export type IdeaIssueReason = (typeof ISSUE_REASONS)[number];

export interface IdeaIssueSnapshotSide {
  optionType: 'put' | 'call';
  shortStrike: number;
  longStrike: number;
  shortBid: number | null;
  shortAsk: number | null;
  shortMark: number | null;
  longMark: number | null;
  shortDelta?: number | null;
  shortIV?: number | null;
}

export interface IdeaIssueSnapshot {
  symbol: string;
  strategy: IdeaIssueStrategy;
  expiration: string;          // YYYY-MM-DD
  dte: number;
  credit: number;              // engine units: dollars per spread ×1 (per-share × 100)
  returnOnRisk: number;
  widthPoints: number;
  underlyingPrice: number;
  source: string;              // 'schwab' | 'tradier' | 'yahoo' | other
  capturedAt: Date;
  sides: IdeaIssueSnapshotSide[]; // 1 for a vertical, 2 for an iron condor
}

export interface Diff {
  primary: number | null;
  secondary: number | null;
  delta: number | null;        // secondary - primary when both are numbers, else null
}

export interface IdeaIssueComparisonLeg {
  optionType: 'put' | 'call';
  shortStrike: number;
  longStrike: number;
  short?: { bid: Diff; ask: Diff; mark: Diff };
  long?: { mark: Diff };
}

export interface IdeaIssueComparison {
  secondarySource: 'tradier';
  fetchedAt: Date;
  underlyingPrice?: number | null;
  creditDiff: number | null;   // secondaryCredit - primaryCredit, engine units
  legDiffs: IdeaIssueComparisonLeg[];
}

export interface IdeaIssueRow {
  id: string;
  symbol: string;
  strategy: IdeaIssueStrategy;
  expiration: string;
  reasons: IdeaIssueReason[];
  note: string | null;
  snapshot: IdeaIssueSnapshot;
  comparison: IdeaIssueComparison | null;
  source: string;
  createdAt: Date;
}
